import { Button, styled } from '@mui/material';

export const PrimaryButton = styled(Button)`
  flex: 1;
  height: 48px !important;
  border-radius: 16px;
  box-shadow: none;
  background-color: #4778f5 !important;
  text-transform: none;

  & * {
    color: white !important;
  }

  &.Mui-disabled {
    background: var(
      --background-button-primary-disabled,
      #e9eaec
    ) !important;
    & * {
      color: var(--text-base-quaternary, rgba(10, 15, 41, 0.25));
    }
  }
`;
